import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Space, List, Steps, Button, Modal } from "antd";
import {
  AppstoreAddOutlined,
  FilePdfOutlined,
  ReadOutlined,
  FormOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import { RenderImage } from "./components/renderImage";
import { ItemList } from "../../../components/itemList";
import { ModalFormulario } from "./components/modalFormulario";
import { maskMoney } from "../../../helpers/masks";
import { ModalPdf } from "./components/modalPdf";
const { Text } = Typography;

export const TreinamentosLancamentoModulos = () => {
  const { id_grupo, id_modulo, id_curso } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [formulario, setFormulario] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [pdf, setPdf] = useState(null);
  const [showModalPdf, setShowModalPdf] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // DADOS
  const [curso, setCurso] = useState({});

  useEffect(() => {
    if (id_modulo > 0) {
      carregarModulo(id_modulo);
      carregarCurso(id_curso);
    }
  }, [id_modulo]);

  // CARREGAR
  const carregarModulo = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_modulos/carregar_lancamento/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;

      if (!response?.id) {
        message.error("Conclua os modulos anteriores!");
        navigate(`/treinamentos/lancamento/grupos/cursos/${id_grupo}/detalhes/${id_curso}`);
      } else {
        setDados(response);
      }
    } else {
      message.error(api.response.message);
      navigate("/treinamentos/lancamento/grupos");
    }
    setLoading(false);
  };

  // CARREGAR CURSO
  const carregarCurso = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_cursos/carregar_detalhes/${id}`, []);
    if (api.statusCode === 200) {
      setCurso(api.response.data);
    } else {
      navigate("/treinamentos/lancamento/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // REFAZER MÓDULO
  const refazerModulo = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("post", `v1/treinamentos_modulos/refazer`, { id: id });
    if (api.statusCode === 200) {
      carregarModulo(id_modulo);

      message.success("Módulo atualizado com sucesso!");
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CONCLUIR MÓDULO
  const concluirModulo = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("post", `v1/treinamentos_modulos/concluir_modulo`, { id: id });
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      if (response > 0) {
        navigate(
          `/treinamentos/lancamento/grupos/cursos/${id_grupo}/detalhes/${id_curso}/modulo/${api?.response?.data}`
        );
        message.success("Módulo concluído com sucesso!");
      } else {
        navigate(`/treinamentos/lancamento/grupos/cursos/${id_grupo}/detalhes/${id_curso}`);
        message.success("Treinamento concluído com sucesso!");
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RENDER LIST
  const renderList = (item) => {
    if (item?.tipo === 1) {
      return <div className="content" dangerouslySetInnerHTML={{ __html: item?.html }} />;
    } else if (item?.tipo === 2) {
      return (
        <iframe
          style={{ width: "100%", border: 0, height: 500 }}
          src={`https://www.youtube-nocookie.com/embed/${item?.video_link}`}
          title="Vídeo Portal Colaborador"
          allowFullScreen
        />
      );
    } else if (item?.tipo === 3) {
      return <RenderImage idImagem={item?.id} />;
    } else if (item?.tipo === 4) {
      return (
        <ItemList
          leftComponent={
            <div className="item-collapse-icon">
              <FilePdfOutlined style={{ fontSize: 22, color: "#60b565" }} />
            </div>
          }
          onClick={() => {
            setPdf(item?.id);
            setShowModalPdf(true);
          }}
          hoverable={true}>
          <Space wrap size={10}>
            <Text strong>{item.nome_arquivo}</Text>
          </Space>
        </ItemList>
      );
    }
  };

  const setSteps = (modulos) => {
    const array_steps = [];
    modulos?.forEach((element) => {
      array_steps.push({
        id: element?.id,
        title: element?.descricao,
        disabled: element?.status === -1 ? true : false,
      });
    });

    return array_steps;
  };

  const steps = curso?.modulos?.length > 0 ? setSteps(curso?.modulos) : [];

  const handleOpenFormulario = (id) => {
    setFormulario(id);
    setShowModal(true);
  };

  const hanldeStepNavigate = (id) => {
    navigate(`/treinamentos/lancamento/grupos/cursos/${id_grupo}/detalhes/${id_curso}/modulo/${id}`);
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <ModalFormulario
        id={formulario}
        open={showModal}
        onClose={() => {
          setShowModal(false);
          setFormulario(null);
        }}
        onFinish={() => {
          setFormulario(null);
          setShowModal(false);
          carregarModulo(id_modulo);
        }}
      />
      <ModalPdf
        open={showModalPdf}
        onClose={() => {
          setPdf(null);
          setShowModalPdf(false);
        }}
        id={pdf}
      />
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Treinamentos & Desenvolvimento"
              onClickBack={() => navigate(`/treinamentos/lancamento/grupos/cursos/${id_grupo}/detalhes/${id_curso}`)}
            />
            <HeaderTitle
              title="Trilha de Aprendizagem"
              subtitle={
                <Text italic>
                  <AppstoreAddOutlined /> {curso?.descricao ?? ""}
                </Text>
              }
              icon={<ReadOutlined />}
              loading={loading}
            />
            <Divider />
            <Space direction="vertical" style={{ width: "100%" }}>
              <Card bordered={false} bodyStyle={{ padding: "3%" }}>
                <Steps
                  onChange={(e) => hanldeStepNavigate(steps[e]?.id)}
                  direction={steps?.length > 4 ? "vertical" : "horizontal"}
                  items={steps}
                  current={steps.findIndex((e) => e?.id === dados?.id)}
                />
              </Card>

              <Card bordered={false} bodyStyle={{ padding: "3%" }}>
                <List
                  split={false}
                  header={
                    <Space direction="vertical" align="center" style={{ width: "100%" }}>
                      <Text style={{ fontSize: 32, color: "#60b565" }} strong>
                        {dados?.descricao}
                      </Text>
                      <Text style={{ fontSize: 20 }}>Unidade {dados?.ordem}</Text>
                    </Space>
                  }
                  size="large"
                  itemLayout="vertical"
                  dataSource={dados?.materiais}
                  renderItem={(item) => <List.Item style={{ padding: 15 }}>{renderList(item)}</List.Item>}
                />
              </Card>

              <Card bordered={false} bodyStyle={{ padding: "3%" }}>
                {dados?.formularios?.length > 0 && (
                  <>
                    <List
                      header={
                        <Text style={{ fontSize: 20 }} strong>
                          Avaliações
                        </Text>
                      }
                      size="large"
                      itemLayout="vertical"
                      dataSource={dados?.formularios}
                      renderItem={(item) => (
                        <List.Item style={{ padding: 15 }}>
                          <ItemList
                            leftComponent={
                              <div className="item-collapse-icon" style={{ backgroundColor: "#2194f230" }}>
                                <FormOutlined style={{ fontSize: 22, color: "#2194f2" }} />
                              </div>
                            }
                            onClick={() => handleOpenFormulario(item?.id)}
                            hoverable={true}
                            rightComponent={
                              item?.status === 2 ? (
                                <ClockCircleOutlined style={{ fontSize: 20, color: "#ff5757" }} />
                              ) : (
                                <CheckCircleOutlined style={{ color: "#60b565", fontSize: 20 }} />
                              )
                            }>
                            <Space wrap size={5} direction="vertical">
                              <Text strong>{item.descricao}</Text>
                              <Text>Nota: {maskMoney(item.nota_final ?? 0)}</Text>
                            </Space>
                          </ItemList>
                        </List.Item>
                      )}
                    />
                    <Divider />
                  </>
                )}

                <Space direction="vertical">
                  <Text strong>{`Tentativas: ${dados?.tentativas_realizadas} / ${dados?.tentativas}`}</Text>
                  <Space align="center">
                    {dados?.formularios?.length > 0 && curso.status !== 1 && (
                      <Button
                        style={{ fontWeight: 600, fontSize: 18, height: "auto" }}
                        disabled={
                          dados?.formularios?.filter((e) => e?.status === 2)?.length > 0 ||
                          dados?.tentativas_realizadas === dados?.tentativas
                        }
                        size="large"
                        onClick={() =>
                          modal.confirm({
                            title: "Deseja refazer este modulo?",
                            content: "Você terá que realizar todas as avaliações novamente!",
                            okText: "Sim",
                            cancelText: "Cancelar",
                            onOk() {
                              refazerModulo(dados?.id);
                            },
                          })
                        }
                        danger>
                        Refazer
                      </Button>
                    )}

                    <Button
                      style={{ fontWeight: 600, fontSize: 18, height: "auto" }}
                      type="primary"
                      disabled={dados?.formularios?.filter((e) => e?.status === 2)?.length > 0}
                      onClick={() => concluirModulo(dados?.id)}
                      size="large">
                      Concluir e Continuar
                    </Button>
                  </Space>
                </Space>
              </Card>
            </Space>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
